export default {
  mounted() {
    setTimeout(() => this.initMermaid(), 100)
  },

  updated() {
    setTimeout(() => this.initMermaid(), 100)
  },

  initMermaid() {
    if (window.mermaid) {
      window.mermaid.initialize({ 
        startOnLoad: false,
        theme: 'default',
        flowchart: {
          curve: 'basis',
          nodeSpacing: 50,
          rankSpacing: 50,
        }
      })
      
      try {
        window.mermaid.init(undefined, document.querySelectorAll('.mermaid'))
      } catch (e) {
        console.error('Mermaid init error:', e)
      }
    }
  }
} 